/*
 * FRENESI · Página «Layering» (17/10/2026) — v5, pensada primeiro para o celular.
 *
 * Revelação na rolagem, a luz que segue o cursor, os filtros das duplas, o
 * «Adicionar os dois» (as duas variantes de 5 ml por /cart/add.js, com a sacola
 * lateral aberta e o contador atualizado, como o «Adicionar» da Curadoria) e o
 * Laboratório.
 *
 * No celular (90% de quem visita), nada depende de passar o dedo por cima: o
 * cartão da dupla mostra o essencial e o toque abre a ficha com o resto. Os
 * dois lados do Laboratório são cartões que abrem a busca em tela cheia, com
 * foto, marca, concentração, gênero e preço de cada perfume (no computador, a
 * busca abre numa janela).
 *
 * O Laboratório lê a vitrine pública da curadoria no ERP (a mesma do quiz):
 * entram os perfumes com o decant de 5 ml à venda, fora kits e a marca Frenesi.
 * As notas em comum contam pelos ids da pirâmide da curadoria; o veredito, a
 * dose, a ordem sugerida e o preço dos dois decants seguem o mockup aprovado. O
 * reator em canvas junta as duas nuvens conforme o veredito. Se a vitrine não
 * responder, o Laboratório sai da página em silêncio.
 */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-lx]');
  if (!raiz || raiz.__lx) return;
  raiz.__lx = true;

  var parado = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var comMouse = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var temObservador = 'IntersectionObserver' in window;
  var $ = function (sel, el) { return (el || raiz).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || raiz).querySelectorAll(sel)); };
  var escapa = function (s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  };

  // Revelação na rolagem.
  var revelaveis = $$('[data-lx-revela]');
  if (parado || !temObservador) {
    revelaveis.forEach(function (e) { e.classList.add('is-visivel'); });
  } else {
    var obs = new IntersectionObserver(function (itens) {
      itens.forEach(function (it) {
        if (it.isIntersecting) { it.target.classList.add('is-visivel'); obs.unobserve(it.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    revelaveis.forEach(function (e) { obs.observe(e); });
  }

  // Vídeo da lente: parado para quem pede menos movimento (fica o pôster) e
  // pausado fora da tela, para não gastar bateria.
  var video = $('[data-lx-video]');
  if (video) {
    if (parado) {
      video.removeAttribute('autoplay');
      video.pause();
    } else if (temObservador) {
      new IntersectionObserver(function (itens) {
        if (itens[0].isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        else video.pause();
      }, { threshold: 0.1 }).observe(video);
    }
  }

  // Luz que segue o cursor na abertura e no palco de cada dupla (só com mouse).
  if (comMouse && !parado) {
    var abre = $('[data-lx-abre]');
    var luz = $('[data-lx-luz]');
    if (abre && luz) {
      abre.addEventListener('pointermove', function (e) {
        var r = abre.getBoundingClientRect();
        luz.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        luz.style.setProperty('--my', (e.clientY - r.top) + 'px');
        luz.classList.add('is-ativa');
      });
      abre.addEventListener('pointerleave', function () { luz.classList.remove('is-ativa'); });
    }
    $$('[data-lx-palco]').forEach(function (palco) {
      palco.addEventListener('pointermove', function (e) {
        var r = palco.getBoundingClientRect();
        palco.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        palco.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }

  // Filtros: valem nas quatro famílias; família sem layering do grupo some, e o
  // carrossel volta para o começo.
  var filtros = $$('[data-lx-filtro]');
  filtros.forEach(function (botao) {
    botao.addEventListener('click', function () {
      var grupo = botao.getAttribute('data-lx-filtro');
      filtros.forEach(function (b) { b.setAttribute('aria-pressed', String(b === botao)); });
      $$('.lx-familia').forEach(function (fam) {
        var visiveis = 0;
        $$('.lx-dupla', fam).forEach(function (d) {
          var mostra = grupo === 'todas' || d.getAttribute('data-grupo') === grupo;
          d.hidden = !mostra;
          if (mostra) { visiveis++; d.classList.add('is-visivel'); }
        });
        fam.hidden = visiveis === 0;
        var trilho = $('.lx-trilho', fam);
        if (trilho) trilho.scrollLeft = 0;
        if (fam.lxCarrossel) fam.lxCarrossel();
      });
    });
  });

  // Carrossel (pedido do dono, 17/10): cada família corre para o lado. No
  // celular, um cartão inteiro e a ponta do próximo, com os pontos embaixo; no
  // computador, três por vez, com as setas no cabeçalho. A rolagem e o encaixe
  // são do próprio navegador.
  $$('.lx-familia').forEach(function (fam) {
    var trilho = $('.lx-trilho', fam);
    if (!trilho) return;
    var anterior = $('[data-lx-anterior]', fam);
    var proximo = $('[data-lx-proximo]', fam);
    var pontos = $('.lx-pontos', fam);
    var cartoes = function () { return $$('.lx-dupla', trilho).filter(function (d) { return !d.hidden; }); };
    var passo = function (lista) { return lista.length > 1 ? lista[1].offsetLeft - lista[0].offsetLeft : trilho.clientWidth; };

    var atualiza = function () {
      var lista = cartoes();
      var max = trilho.scrollWidth - trilho.clientWidth;
      var x = trilho.scrollLeft;
      fam.classList.toggle('tem-mais', max > 4);
      if (anterior) anterior.disabled = x <= 4;
      if (proximo) proximo.disabled = x >= max - 4;
      if (!pontos) return;
      if (pontos.children.length !== lista.length) pontos.innerHTML = lista.map(function () { return '<i></i>'; }).join('');
      pontos.hidden = lista.length < 2;
      var ativo = x >= max - 4 ? lista.length - 1 : Math.round(x / passo(lista));
      $$('i', pontos).forEach(function (p, k) { p.classList.toggle('is-ativo', k === ativo); });
    };

    // As setas andam uma tela de cartões por vez.
    var anda = function (sentido) {
      var lista = cartoes();
      var p = passo(lista);
      var porVez = Math.max(1, Math.round(trilho.clientWidth / p));
      trilho.scrollBy({ left: sentido * p * porVez, behavior: parado ? 'auto' : 'smooth' });
    };
    if (anterior) anterior.addEventListener('click', function () { anda(-1); });
    if (proximo) proximo.addEventListener('click', function () { anda(1); });

    // O cartão que entra pelo lado aparece logo, sem esperar a revelação da rolagem.
    var agendado = false;
    trilho.addEventListener('scroll', function () {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(function () {
        agendado = false;
        cartoes().forEach(function (d) { d.classList.add('is-visivel'); });
        atualiza();
      });
    }, { passive: true });
    window.addEventListener('resize', atualiza);
    fam.lxCarrossel = atualiza;
    atualiza();
  });

  // ── Sacola ──
  function retorno(botao, texto, erro) {
    if (botao.__lxRotulo == null) botao.__lxRotulo = botao.innerHTML;
    botao.classList.remove('is-carregando');
    botao.classList.add(erro ? 'is-erro' : 'is-feito');
    botao.textContent = texto;
    setTimeout(function () {
      botao.classList.remove('is-feito', 'is-erro');
      botao.innerHTML = botao.__lxRotulo;
      // O laboratório pode ter travado o botão enquanto o aviso aparecia (mesmo perfume nos dois lados).
      botao.disabled = botao.hasAttribute('data-lx-bloqueado');
    }, 2200);
  }

  // As duas variantes de 5 ml: o mesmo aviso que o formulário do produto dá
  // (a sacola se redesenha e o número do ícone atualiza) e a sacola abre.
  function adicionar(variantes, botao) {
    var itens = String(variantes || '').split(',').map(function (v) { return { id: parseInt(v, 10), quantity: 1 }; })
      .filter(function (i) { return i.id; });
    if (!itens.length || botao.disabled) return;
    botao.disabled = true;
    botao.classList.add('is-carregando');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: itens })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'erro');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (carrinho) {
        var aviso = new Event('cart:update', { bubbles: true });
        aviso.detail = {
          resource: carrinho,
          sourceId: 'frenesi-layering',
          data: { source: 'frenesi-layering', itemCount: carrinho.item_count, variantId: String(itens[0].id) }
        };
        document.dispatchEvent(aviso);
        if (janela && janela.el.contains(botao)) fechaJanela(false);
        var sacola = document.querySelector('cart-drawer-component');
        if (sacola && !sacola.hasAttribute('auto-open') && typeof sacola.open === 'function') sacola.open();
        retorno(botao, 'Adicionados à sacola');
      })
      ['catch'](function () { retorno(botao, 'Não foi possível adicionar', true); });
  }
  // Um ouvinte só para todos os «Adicionar os dois»: os dos cartões e o da
  // ficha da dupla, que é uma cópia do cartão aberta por cima da página.
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-lx-adicionar]') : null;
    if (!b || !(raiz.contains(b) || (folha && folha.contains(b)))) return;
    adicionar(b.getAttribute('data-variantes'), b);
  });

  var XIS = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  // ── Janelas (a ficha da dupla e a busca do laboratório) ──
  // Uma por vez. No celular, o «voltar» do aparelho fecha a janela em vez de
  // sair da página; a página por trás não rola enquanto ela está aberta.
  var janela = null;
  function abreJanela(el, aoFechar, foco) {
    if (janela) fechaJanela(false);
    janela = { el: el, aoFechar: aoFechar, volta: document.activeElement, empilhou: false };
    el.hidden = false;
    document.documentElement.classList.add('lx-travado');
    try { history.pushState({ lxJanela: true }, ''); janela.empilhou = true; } catch (err) {}
    (foco || el).focus({ preventScroll: true });
  }
  function fechaJanela(peloVoltar) {
    if (!janela) return;
    var j = janela;
    janela = null;
    j.el.hidden = true;
    document.documentElement.classList.remove('lx-travado');
    if (j.aoFechar) j.aoFechar();
    if (j.volta && j.volta.focus) j.volta.focus({ preventScroll: true });
    if (j.empilhou && !peloVoltar) history.back();
  }
  window.addEventListener('popstate', function () { if (janela) fechaJanela(true); });
  document.addEventListener('keydown', function (e) {
    if (!janela) return;
    if (e.key === 'Escape') { e.preventDefault(); fechaJanela(false); return; }
    if (e.key !== 'Tab') return;
    // O foco fica dentro da janela.
    var focaveis = Array.prototype.filter.call(
      janela.el.querySelectorAll('button:not([disabled]), input, a[href], [tabindex="0"]'),
      function (x) { return x.offsetParent !== null; });
    if (!focaveis.length) return;
    var primeiro = focaveis[0], ultimo = focaveis[focaveis.length - 1];
    if (e.shiftKey && document.activeElement === primeiro) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primeiro.focus(); }
  });

  // ── O tamanho de cada perfume ──
  // A pessoa escolhe o tamanho de cada um (pedido do dono, 17/10). A escolha
  // começa no 3 ml (escolha do dono, 17/10) e fica à vista; o total acompanha.
  // Perfume sem 3 ml à venda começa no menor tamanho que houver.
  var TAMANHO_INICIAL = 3;
  var dinheiro = function (v) { return Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); };
  function tamanhoInicial(tams, ml) {
    return tams.filter(function (t) { return t.ml === ml; })[0] || tams[0];
  }
  // lados: [{ papel, nome, tams: [{ ml, preco, v }], ml }]; aoMudar(escolhidos) a cada troca.
  function seletorDeTamanhos(lados, aoMudar) {
    var caixa = document.createElement('div');
    caixa.className = 'lx-tamanhos';
    var escolhidos = lados.map(function (l) { return tamanhoInicial(l.tams, l.ml); });
    function desenha() {
      caixa.innerHTML = '<p class="lx-tamanhos__titulo">Escolha o tamanho de cada um</p>' + lados.map(function (l, i) {
        return '<div class="lx-tamanho"><p class="lx-tamanho__rotulo"><span>' + escapa(l.papel) + '</span><b>' + escapa(l.nome) + '</b>' +
          '<em>' + dinheiro(escolhidos[i].preco) + '</em></p><div class="lx-tamanho__opcoes" role="radiogroup" aria-label="Tamanho de ' + escapa(l.nome) + '">' +
          l.tams.map(function (t) {
            var sel = t.ml === escolhidos[i].ml;
            return '<button type="button" role="radio" aria-checked="' + sel + '"' + (sel ? '' : ' tabindex="-1"') +
              ' data-lado="' + i + '" data-ml="' + t.ml + '" aria-label="' + t.ml + ' ml, ' + dinheiro(t.preco) + '">' + t.ml + ' ml</button>';
          }).join('') + '</div></div>';
      }).join('');
    }
    function escolhe(i, ml, focar) {
      escolhidos[i] = lados[i].tams.filter(function (t) { return t.ml === ml; })[0] || escolhidos[i];
      desenha();
      if (focar) caixa.querySelector('[data-lado="' + i + '"][aria-checked="true"]').focus();
      aoMudar(escolhidos.slice());
    }
    caixa.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ml]');
      if (b) escolhe(Number(b.getAttribute('data-lado')), Number(b.getAttribute('data-ml')), true);
    });
    // Como num grupo de opções: as setas trocam o tamanho.
    caixa.addEventListener('keydown', function (e) {
      var b = e.target.closest('[data-ml]');
      var passo = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!b || !passo) return;
      e.preventDefault();
      var i = Number(b.getAttribute('data-lado'));
      var k = lados[i].tams.map(function (t) { return t.ml; }).indexOf(escolhidos[i].ml);
      var prox = lados[i].tams[(k + passo + lados[i].tams.length) % lados[i].tams.length];
      escolhe(i, prox.ml, true);
    });
    desenha();
    aoMudar(escolhidos.slice());
    return caixa;
  }
  // Os tamanhos à venda de cada lado do cartão (o tema escreve no cartão).
  function ladosDoCartao(cartao) {
    var nomes = $$('.lx-dupla__par dd > a', cartao).map(function (a) { return a.textContent.trim(); });
    var lados = ['base', 'topo'].map(function (lado, i) {
      var tams = [];
      try { tams = JSON.parse(cartao.getAttribute('data-tamanhos-' + lado) || '[]'); } catch (e) {}
      tams = tams.filter(function (t) { return t.ok; }).map(function (t) { return { ml: Number(t.ml), preco: Number(t.preco) / 100, v: String(t.id) }; })
        .sort(function (a, b) { return a.ml - b.ml; });
      return { papel: i ? 'Por cima' : 'Base', nome: nomes[i] || '', tams: tams, ml: TAMANHO_INICIAL };
    });
    return lados[0].tams.length && lados[1].tams.length ? lados : null;
  }

  // ── Ficha da dupla ──
  // O cartão mostra o essencial; um toque (ou clique) abre a ficha com o
  // porquê, as notas em comum e a dose. No celular ela sobe de baixo; no
  // computador, abre numa janela.
  var celular = window.matchMedia('(max-width: 749px)');
  var folha = null;
  function criaFolha() {
    folha = document.createElement('div');
    folha.className = 'lx lx-folha';
    folha.hidden = true;
    folha.setAttribute('role', 'dialog');
    folha.setAttribute('aria-modal', 'true');
    folha.tabIndex = -1;
    folha.innerHTML = '<div class="lx-folha__fundo" data-lx-fechar></div>' +
      '<div class="lx-folha__caixa"><span class="lx-folha__alca" aria-hidden="true"></span>' +
      '<button type="button" class="lx-fechar" data-lx-fechar aria-label="Fechar">' + XIS + '</button>' +
      '<div class="lx-folha__corpo"></div></div>';
    folha.addEventListener('click', function (e) {
      if (e.target.closest('[data-lx-fechar]')) fechaJanela(false);
    });
    document.body.appendChild(folha);
  }
  function abreFicha(cartao, escolher) {
    if (!folha) criaFolha();
    var copia = cartao.cloneNode(true);
    copia.removeAttribute('data-lx-revela');
    copia.classList.add('lx-dupla--ficha');
    var abrir = copia.querySelector('.lx-dupla__abrir');
    if (abrir) abrir.remove();
    $$('[tabindex="-1"]', copia).forEach(function (a) { a.removeAttribute('tabindex'); a.removeAttribute('aria-hidden'); });
    // Na ficha, a pessoa escolhe o tamanho de cada um antes de pôr na sacola.
    var lados = ladosDoCartao(cartao);
    var seletor = null;
    var botao = copia.querySelector('[data-lx-escolher]');
    if (lados && botao) {
      var preco = copia.querySelector('.lx-dupla__preco');
      seletor = seletorDeTamanhos(lados, function (esc) {
        preco.innerHTML = '<small>Total</small><strong>' + dinheiro(esc[0].preco + esc[1].preco) + '</strong>';
        botao.removeAttribute('data-lx-escolher');
        botao.setAttribute('data-lx-adicionar', '');
        botao.setAttribute('data-variantes', esc[0].v + ',' + esc[1].v);
        botao.setAttribute('aria-label', 'Adicionar ' + lados[0].nome + ' (' + esc[0].ml + ' ml) e ' + lados[1].nome + ' (' + esc[1].ml + ' ml) à sacola');
      });
      var rodape = copia.querySelector('.lx-dupla__rodape');
      rodape.parentNode.insertBefore(seletor, rodape);
    }
    var corpo = folha.querySelector('.lx-folha__corpo');
    corpo.innerHTML = '';
    corpo.appendChild(copia);
    var nome = copia.querySelector('.lx-dupla__nome');
    folha.setAttribute('aria-label', 'Layering ' + (nome ? nome.textContent : ''));
    abreJanela(folha, null, folha);
    // Pelo «Adicionar» do cartão, a ficha abre já na escolha dos tamanhos.
    if (escolher && seletor) {
      seletor.scrollIntoView({ block: 'center' });
      seletor.querySelector('[aria-checked="true"]').focus({ preventScroll: true });
    }
  }
  // Um botão invisível cobre o cartão (o «Adicionar» fica por cima dele): o
  // cartão inteiro abre a ficha, e quem usa o teclado também chega nela.
  $$('.lx-trilho .lx-dupla').forEach(function (cartao) {
    var nome = cartao.querySelector('.lx-dupla__nome');
    var abrir = document.createElement('button');
    abrir.type = 'button';
    abrir.className = 'lx-dupla__abrir';
    abrir.innerHTML = '<span class="lx-sr">Ver por que ' + escapa(nome ? nome.textContent : 'o layering') + ' combina</span>';
    abrir.addEventListener('click', function () { abreFicha(cartao); });
    cartao.appendChild(abrir);
    var escolher = cartao.querySelector('[data-lx-escolher]');
    if (escolher) escolher.addEventListener('click', function () { abreFicha(cartao, true); });
  });

  // ── Laboratório ──
  var lab = $('[data-lx-lab]');
  if (!lab) return;

  var semAcento = function (s) { return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); };
  var brl = function (v) { return Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); };
  var familiaLegivel = function (f) {
    return (f || '').replace(/\s*•\s*/g, ' ').replace(/\bfruity\b/gi, 'frutado').replace(/\bmusk\b/gi, 'almíscar').trim();
  };

  function macro(f) {
    var x = semAcento(f);
    if (/gourmand|baunilh|doce/.test(x)) return 'doce';
    if (/aquatic|citric|verde/.test(x) || /^(aromatic|frutad|frutal|chipre frutad|chypre frutad)/.test(x)) return 'fresco';
    if (/^(floral|chipre floral|chypre floral)/.test(x)) return 'floral';
    return 'quente';
  }
  var NOME = { doce: ['doce', 'doces'], fresco: ['fresco', 'frescos'], floral: ['floral', 'florais'], quente: ['amadeirado', 'amadeirados'] };
  var CONTRASTE = {
    'doce|fresco': 'o frescor deixa o doce mais leve',
    'fresco|quente': 'o frescor ilumina o fundo amadeirado',
    'floral|quente': 'o fundo amadeirado dá corpo às flores',
    'doce|floral': 'as flores deixam o doce mais elegante',
    'floral|fresco': 'o frescor deixa as flores mais luminosas',
    'doce|quente': 'o doce arredonda o fundo amadeirado'
  };
  // Cores das nuvens do reator e da aura da foto, por família.
  var CORES = {
    floral: ['#d98aa0', '#f2c2cd'],
    fresco: ['#64a8bd', '#a4d5c8'],
    doce: ['#cf9548', '#f0c88c'],
    quente: ['#7d5f45', '#b8916d']
  };
  var FUSAO = { forte: 0.95, boa: 0.8, contraste: 0.55, ousada: 0.3, nenhuma: 0 };

  function lista(nomes) {
    if (nomes.length === 1) return nomes[0];
    return nomes.slice(0, -1).join(', ') + ' e ' + nomes[nomes.length - 1];
  }

  function notasEmComum(a, b) {
    var nomes = {};
    a.no.forEach(function (n) { (nomes[n[0]] = nomes[n[0]] || []).push(n[1]); });
    var vistos = {};
    var comuns = [];
    b.no.forEach(function (n) {
      if (nomes[n[0]] && !vistos[n[0]]) {
        vistos[n[0]] = true;
        var todos = nomes[n[0]].concat([n[1]]).sort(function (x, y) { return x.length - y.length; });
        comuns.push(todos[0].toLowerCase());
      }
    });
    return comuns;
  }

  // O gênero sai do nome do produto, como no ERP (o endereço da loja traz
  // «-feminino-», «-masculino-» ou «-unissex-»; «homme», «uomo», «donna»…
  // também contam). Sem marcação, o perfume fica sem etiqueta de gênero.
  var GENEROS = { feminino: 'Feminino', masculino: 'Masculino', unissex: 'Unissex' };
  function generoDe(texto) {
    var t = ' ' + semAcento(texto).replace(/[^a-z0-9]+/g, ' ') + ' ';
    if (/ unisse?x /.test(t)) return 'unissex';
    if (/ masculin| homme | uomo | men | man | for him /.test(t)) return 'masculino';
    if (/ feminin| femme | donna | women | woman | for her /.test(t)) return 'feminino';
    return '';
  }
  // Quem busca por «edp» ou «edt» também acha.
  var SIGLAS = [[/eau de parfum/, 'edp'], [/eau de toilette/, 'edt'], [/eau de cologne/, 'edc'], [/extrait/, 'extrato']];

  // Da vitrine da curadoria aos perfumes do Laboratório.
  function perfumesDoLab(dados) {
    var saida = [];
    var todos = (dados && dados.perfumes) || {};
    Object.keys(todos).forEach(function (h) {
      var p = todos[h];
      if (!p || /^kit/.test(h) || String(p.marca || '').toUpperCase() === 'FRENESI') return;
      // Os tamanhos à venda; a pessoa escolhe o de cada um. O tamanho em que a
      // escolha começa (o 3 ml, ou o menor à venda) dá o preço da busca.
      var tams = (p.tamanhos || []).filter(function (t) { return t.disponivel; })
        .map(function (t) { return { ml: Number(t.ml), preco: Number(t.preco), v: String(t.variante) }; })
        .sort(function (a, b) { return a.ml - b.ml; });
      var tRef = tamanhoInicial(tams, TAMANHO_INICIAL);
      if (!tRef) return;
      var ficha = p.ficha || {};
      var pir = ficha.piramide || {};
      var no = [];
      var todas = [];
      var total = 0;
      ['saida', 'coracao', 'fundo'].forEach(function (camada, i) {
        (pir[camada] || []).forEach(function (n) {
          total++;
          // O nome canônico da nota (o da tabela de notas) vence o nome de vitrine.
          var canon = n && n.id != null && dados.notas ? dados.notas[n.id] : null;
          var nota = [n && n.id != null ? n.id : null, (canon && canon.nome) || (n && n.nome) || '', i];
          todas.push(nota);
          if (nota[0] != null) no.push(nota);
        });
      });
      if (!total) return;
      var c = p.concentracao || '';
      var g = generoDe(h + ' ' + p.nome);
      var busca = semAcento([p.nome, p.marca, c, g].join(' '));
      SIGLAS.forEach(function (s) { if (s[0].test(busca)) busca += ' ' + s[1]; });
      // A foto inteira da vitrine; o CSS mostra só o miolo (veja o laboratorio.css).
      var img = p.imagem ? p.imagem + (p.imagem.indexOf('?') >= 0 ? '&' : '?') + 'width=360' : '';
      var perfume = {
        h: h, n: p.nome, m: p.marca || '', c: c, g: g, f: ficha.familia || '', no: no, busca: busca,
        it: ficha.intensidade ? ficha.intensidade.nivel : null,
        fx: ficha.fixacao ? ficha.fixacao.nivel : null,
        pRef: tRef.preco, mlRef: tRef.ml, tams: tams, img: img
      };
      // Os acordes (todos e só os que duram) e a família na roda, para as regras.
      perfume.ac = acordesDe(todas);
      perfume.acD = acordesDe(todas, [1, 2]);
      if (!Object.keys(perfume.acD).length) perfume.acD = perfume.ac;
      perfume.roda = rodaDe(perfume);
      saida.push(perfume);
    });
    return saida;
  }

  // ── Regras do Laboratório (17/10) ──
  // A base de conhecimento (entregas/tema/layering/pesquisa) traz a fonte de
  // cada regra. O Laboratório só diz «Recomendado» para os layerings da
  // seleção da página (decisões do dono de 17/10); fora dela, no máximo
  // «boa aposta pelas notas», sempre com o motivo à vista.

  // Acordes: grupos de notas que o nariz percebe como uma coisa só.
  var ACORDES = [
    ['marinho', /^(acordes? marinhos?|agua do mar|acordes? aquaticos?|salgad.*|calone|notas aquaticas|notas oceanicas|notas marinhas|sal|sal marinho|alga marinha|notas ozonicas|aquozone|acorde marinho|agua)$/],
    ['cítrico', /^(casca de limao|toque citrico|notas citricas|pergamota|bergamota.*|limao.*|toranja|grapefruit|laranja.*|mandarina.*|tangerina.*|lima|yuzu|citricos|verbena|cidra|mandora|caviar de lima|neroli|petitgrain|flor de grapefruit)$/],
    ['lavanda', /^(lavanda.*|lavandin)$/],
    ['ervas', /^(canfora|folhas? de figueira|acordes frescos|geranio.*|folhas? verdes|folhas? de trevo|trevo.*|pinho|agulhas de pinheiro|junipero|folha de louro|acordes aromaticos|aromaticas|salvia.*|alecrim|hortela|menta|manjericao|tomilho|estragao|artemisia|notas verdes|cha|folhas de violeta|galbano|absinto|zimbro|bagas de zimbro|notas aromaticas|ervas.*)$/],
    ['flores brancas', /^(jasmin|hedione|oleo de monoi|acordes florais brancos|flores brancas intensificadas|lirio-do-vale|tuberosas|petalas brancas|jasmim.*|tuberosa|flor de laranjeira.*|gardenia|ylang.*|tiare|flores brancas|lirio|magnolia|flor de coco|camelia branca|datura|frangipani)$/],
    ['rosa', /^(rosa.*|peonia|rosyfolia.*|petalia)$/],
    ['frutas', /^(davana|maninka|ruibarbo|lichia.*|marmelo.*|tamaras?|pera|maca.*|pessego|frutas vermelhas|cassis|groselha.*|abacaxi|cereja.*|framboesa|amora|ameixa|damasco|melao|melancia|manga|maracuja|frutas tropicais|notas frutadas|morango.*|bagas vermelhas|goiaba|kiwi|figo|roma|mirabelle|caqui|carambola)$/],
    ['baunilha', /^(xarope de bordo|acordes doces|mel|cumaru|fava-tonka|absoluto de baunilha|sorvete de baunilha|pipoca caramelizada|baunilha.*|fava tonka|cumarina|caramelo.*|praline|toffee|marshmallow|algodao-doce|acucar.*|merengue|cupcake|acordes gourmand)$/],
    ['cacau e café', /^(cafe verde|cacau|chocolate|cafe|cocoapulse.*)$/],
    ['coco e nozes', /^(creme de leite|notas lactonicas|coco|leite de coco|amendoa.*|avela|pistache|castanha|leite)$/],
    ['âmbar e resinas', /^(ambar.*|notas resinosas|resina.*|labdano|abeto balsamico|ladano|benjoim|incenso|olibano|mirra|resinas|elemi|balsamos|balsamo.*|estoraque|mastique|amberwood|ambroxan|ambrox super|ambrofix.*)$/],
    ['especiarias', /^(casia|cardamomo.*|especiarias.*|notas especiadas|especiadas|cravo-da-india|cassia|alcaravia|noz.moscada|canela|pimenta.*|acafrao|cravo|gengibre|coentro|anis.*|alcacuz|cominho|notas orientais)$/],
    ['oud e couro', /^(narguile|oud.*|couro|camurca|tabaco|fumaca|carvao)$/],
    ['madeiras', /^(cedro.*|teca|madeira de teca|nagarmota.*|musgo.*|bambu|notas amadeiradas.*|acordes amadeirados|sandalo.*|vetiver.*|patchouli.*|madeira.*|guaiac.*|cipreste|cashmeran|akigalawood|papyrus|clearwood.*|palo santo|betula|pau-brasil|jacaranda|carvalho|acorde amadeirado)$/],
    ['almíscar', /^(almiscar.*|ambreta|serenolide.*|notas atalcadas)$/],
    ['bebidas', /^(rum|licor.*|conhaque|acorde de uisque|champanhe.*|levemente alcoolica|vodka)$/],
    ['flores', /^(ciclamen|mahonial.*|fresia.*|orquidea|jacinto|flor de lotus|lotus|camomila|notas florais|toques florais|flores frescas|flor de pera|flor de pessego|flor de toranja|lilas|narciso|osmanthus|mimosa|cravo frances)$/],
    ['íris e violeta', /^(raiz de iris|orris|violeta.*|folhas? de violeta|iris|raiz de orris|heliotropio)$/]
  ];
  // Como cada acorde aparece no texto do resultado.
  var ACORDE_NO_TEXTO = {
    'marinho': 'notas marinhas', 'cítrico': 'cítricos', 'ervas': 'ervas aromáticas', 'coco e nozes': 'notas cremosas de coco e amêndoa',
    'bebidas': 'notas licorosas', 'âmbar e resinas': 'âmbar e resinas', 'oud e couro': 'oud e couro'
  };
  // Fundo que quase todo perfume tem: dividir só ele não faz ponte.
  var FUNDO_DE_TODOS = { 'almíscar': true, 'madeiras': true, 'âmbar e resinas': true };
  var QUENTES = ['baunilha', 'cacau e café', 'coco e nozes', 'âmbar e resinas', 'especiarias', 'oud e couro', 'bebidas'];
  var DOCES = ['baunilha', 'cacau e café', 'coco e nozes', 'bebidas'];
  var FRESCOS = ['cítrico', 'ervas', 'lavanda', 'marinho'];
  var FLORAIS = ['flores brancas', 'rosa', 'flores', 'íris e violeta'];
  // A saída pesa menos: evapora nos primeiros minutos.
  var PESO_CAMADA = [0.7, 1, 1.1];
  // Pares clássicos: [acorde da base, mínimo, acorde de cima, mínimo, só nesse sentido, frase].
  var CLASSICOS = [
    ['oud e couro', 0.08, 'rosa', 0.2, false, 'Rosa e oud são o par clássico da perfumaria árabe.'],
    ['baunilha', 0.15, 'lavanda', 0.15, false, 'Lavanda e baunilha formam um acorde clássico da perfumaria.'],
    ['almíscar', 0.25, 'cítrico', 0.3, true, 'Cítrico por cima de almíscar é um clássico: fica mais quente que o cítrico e mais fresco que o almíscar.']
  ];

  function acordeDaNota(nome) {
    var x = semAcento(nome).trim();
    for (var k = 0; k < ACORDES.length; k++) if (ACORDES[k][1].test(x)) return ACORDES[k][0];
    return null;
  }

  // Peso de cada acorde no perfume (0 a 1); «camadas» limita a saída, o coração e o fundo.
  function acordesDe(no, camadas) {
    var soma = {}, total = 0;
    no.forEach(function (n) {
      if (camadas && camadas.indexOf(n[2]) < 0) return;
      var w = PESO_CAMADA[n[2]] || 1;
      total += w;
      var a = acordeDaNota(n[1]);
      if (a) soma[a] = (soma[a] || 0) + w;
    });
    if (total) Object.keys(soma).forEach(function (k) { soma[k] /= total; });
    return soma;
  }

  function somaDe(ac, lista) { return lista.reduce(function (t, k) { return t + (ac[k] || 0); }, 0); }

  // A família na roda de Michael Edwards: fresco, floral, ambar ou amadeirado.
  function rodaDe(p) {
    var f = semAcento(p.f);
    if (/oriental|ambar|ambarado|gourmand|baunilh|doce/.test(f) || somaDe(p.ac, QUENTES) >= 0.4) return 'ambar';
    if (/^(floral|frutado|frutal|chipre floral|chypre floral|neo.chypre floral)/.test(f)) return 'floral';
    if (/aquatic|citric|verde|aromatic|fougere/.test(f) && !/^amadeirad/.test(f)) return 'fresco';
    if (/^(chipre frutado|chypre frutado|chypre citrico)/.test(f)) return somaDe(p.ac, FLORAIS) >= 0.2 ? 'floral' : 'fresco';
    if (/^(amadeirad|couro|especiado)/.test(f)) return 'amadeirado';
    return somaDe(p.ac, FRESCOS) >= 0.45 ? 'fresco' : 'amadeirado';
  }

  function tracosDe(p) {
    var i = p.it == null ? 3 : p.it;
    var quente = somaDe(p.ac, QUENTES);
    return {
      int: i,
      doce: somaDe(p.ac, DOCES) >= 0.25,
      pesado: i >= 4 && (quente >= 0.35 || p.roda === 'ambar'),
      claro: somaDe(p.ac, FRESCOS) >= 0.35 && quente <= 0.2 && i <= 3.5,
      aquatico: (p.ac.marinho || 0) >= 0.2 || /aquat/.test(semAcento(p.f))
    };
  }

  // A ponte precisa durar: conta o coração e o fundo dos dois.
  function pontesEntre(a, b) {
    return Object.keys(a.acD).filter(function (x) {
      var limite = FUNDO_DE_TODOS[x] ? 0.3 : 0.12;
      return (b.acD[x] || 0) >= limite && a.acD[x] >= limite;
    }).sort(function (x, y) { return (b.acD[y] + a.acD[y]) - (b.acD[x] + a.acD[x]); });
  }

  // O veredito pelas notas: 'evite', 'boa' (ponte, clássico ou contraste) ou 'incerto'.
  function avaliaPar(b, t) {
    var tb = tracosDe(b), tt = tracosDe(t);
    var conflitos = [];
    if (tb.pesado && tt.pesado) conflitos.push('dois-pesados');
    if (tb.doce && tt.doce) conflitos.push('doce-sobre-doce');
    if ((tb.aquatico && tt.pesado) || (tt.aquatico && tb.pesado)) conflitos.push('aquatico-com-pesado');
    var r = { tb: tb, tt: tt, conflitos: conflitos, pontes: pontesEntre(b, t), classico: null, contraste: false };
    CLASSICOS.forEach(function (c) {
      if ((b.ac[c[0]] || 0) >= c[1] && (t.ac[c[2]] || 0) >= c[3]) r.classico = c[5];
      else if (!c[4] && (t.ac[c[0]] || 0) >= c[1] && (b.ac[c[2]] || 0) >= c[3]) r.classico = c[5];
    });
    r.contraste = tt.claro && (tb.pesado || b.roda === 'ambar' || b.roda === 'amadeirado') && tb.int - tt.int >= 0.5;
    if (conflitos.length) r.veredito = 'evite';
    else if (r.pontes.length) r.veredito = 'boa', r.motivo = 'ponte';
    else if (r.classico) r.veredito = 'boa', r.motivo = 'classico';
    else if (r.contraste) r.veredito = 'boa', r.motivo = 'contraste';
    else r.veredito = 'incerto';
    return r;
  }

  // ── Reator: duas nuvens de partículas que se aproximam conforme o veredito ──
  var reator = (function () {
    var canvas = $('[data-lx-reator]', lab);
    if (!canvas || !canvas.getContext) return { muda: function () {} };
    var ctx = canvas.getContext('2d');
    var W = 0;
    var est = { f: 0.5, alvo: 0.5, cores: [CORES.quente, CORES.fresco], forca: 1, forcaAlvo: 1 };
    var particulas = [];
    var semente = 7;
    var aleat = function () { semente = (semente * 16807) % 2147483647; return (semente - 1) / 2147483646; };
    // Cada perfume é um disco de partículas inclinado; os dois discos se cruzam.
    for (var k = 0; k < 2; k++) {
      for (var i = 0; i < 170; i++) {
        particulas.push({
          k: k,
          a: aleat() * Math.PI * 2,
          r: 0.22 + 0.78 * Math.sqrt(aleat()),
          w: (0.6 + aleat() * 0.8) * (k ? -1 : 1),
          s: 0.55 + aleat() * 1.25,
          tom: aleat(),
          fase: aleat() * Math.PI * 2
        });
      }
    }
    function hexRgb(h) { var n = parseInt(h.slice(1), 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; }
    var OURO = [201, 161, 79];
    function mede() {
      var r = canvas.getBoundingClientRect();
      if (!r.width) return;
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      W = r.width;
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(W * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function halo(x, y, raio, rgb, alfa) {
      var g = ctx.createRadialGradient(x, y, 0, x, y, raio);
      g.addColorStop(0, 'rgba(' + rgb.join(',') + ',' + alfa + ')');
      g.addColorStop(1, 'rgba(' + rgb.join(',') + ',0)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(x, y, raio, 0, Math.PI * 2);
      ctx.fill();
    }
    function quadro(t) {
      if (!W) mede();
      if (!W) return;
      est.f += (est.alvo - est.f) * 0.05;
      est.forca += (est.forcaAlvo - est.forca) * 0.08;
      ctx.clearRect(0, 0, W, W);
      var cx = W / 2, cy = W / 2;
      var R = W * 0.3;
      var sep = R * (0.95 - est.f * 0.82);
      var c0 = [cx - sep, cy], c1 = [cx + sep, cy];
      var rgb0 = [hexRgb(est.cores[0][0]), hexRgb(est.cores[0][1])];
      var rgb1 = [hexRgb(est.cores[1][0]), hexRgb(est.cores[1][1])];

      // Escala do instrumento.
      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate(t * 0.00004);
      for (var j = 0; j < 90; j++) {
        var longo = j % 15 === 0;
        var ang = j / 90 * Math.PI * 2;
        var r1 = W * 0.485, r2 = W * (longo ? 0.455 : 0.472);
        ctx.strokeStyle = longo ? 'rgba(21,18,14,0.42)' : 'rgba(21,18,14,0.16)';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(Math.cos(ang) * r1, Math.sin(ang) * r1);
        ctx.lineTo(Math.cos(ang) * r2, Math.sin(ang) * r2);
        ctx.stroke();
      }
      ctx.restore();

      // Auras dos dois discos e o brilho do encontro.
      halo(c0[0], c0[1], R * 1.3, rgb0[1], 0.42 * est.forca);
      halo(c1[0], c1[1], R * 1.3, rgb1[1], 0.42 * est.forca);
      halo(cx, cy, R * (0.35 + est.f * 0.6), OURO, 0.32 * est.f * est.forca);

      // Órbita de cada disco (elipse inclinada).
      var INCL = [-0.5, 0.5], ACHAT = 0.4;
      [[c0, rgb0[0], INCL[0]], [c1, rgb1[0], INCL[1]]].forEach(function (d) {
        ctx.strokeStyle = 'rgba(' + d[1].join(',') + ',' + (0.38 * est.forca).toFixed(3) + ')';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.ellipse(d[0][0], d[0][1], R * 1.02, R * 1.02 * ACHAT, d[2], 0, Math.PI * 2);
        ctx.stroke();
      });

      // Partículas: a parte da frente do disco é maior e mais nítida; no
      // encontro dos dois discos, puxam para o dourado.
      for (var q = 0; q < particulas.length; q++) {
        var p = particulas[q];
        var c = p.k ? c1 : c0, o = p.k ? c0 : c1;
        var incl = INCL[p.k];
        var a = p.a + t * 0.00022 * p.w;
        var rr = R * p.r * (1 + 0.04 * Math.sin(t * 0.0012 + p.fase));
        var ex = Math.cos(a) * rr, ey = Math.sin(a) * rr * ACHAT;
        var x = c[0] + ex * Math.cos(incl) - ey * Math.sin(incl);
        var y = c[1] + ex * Math.sin(incl) + ey * Math.cos(incl);
        var frente = (Math.sin(a) + 1) / 2;
        var base = p.tom < 0.55 ? (p.k ? rgb1[0] : rgb0[0]) : (p.k ? rgb1[1] : rgb0[1]);
        var dist = Math.hypot(x - o[0], y - o[1]);
        var mix = Math.max(0, 1 - dist / (R * 0.9)) * est.f * 0.9;
        var cor = [0, 1, 2].map(function (m) { return Math.round(base[m] + (OURO[m] - base[m]) * mix); });
        ctx.fillStyle = 'rgba(' + cor.join(',') + ',' + ((0.22 + 0.7 * frente) * est.forca).toFixed(3) + ')';
        ctx.beginPath();
        ctx.arc(x, y, p.s * (0.6 + 0.8 * frente) * (1 + mix * 0.5), 0, Math.PI * 2);
        ctx.fill();
      }

      // Núcleo do encontro: um ponto de luz que cresce com a sintonia.
      if (est.f > 0.05) halo(cx, cy, 10 + 26 * est.f, [255, 250, 240], 0.9 * est.f * est.forca);
    }
    var rodando = false, visivel = !temObservador;
    function laco(t) {
      quadro(t);
      if (rodando) requestAnimationFrame(laco);
    }
    function liga() {
      if (parado) { requestAnimationFrame(function (t) { est.f = est.alvo; est.forca = est.forcaAlvo; quadro(t); }); return; }
      if (!rodando && visivel) { rodando = true; requestAnimationFrame(laco); }
    }
    if (temObservador) {
      new IntersectionObserver(function (itens) {
        visivel = itens[0].isIntersecting;
        if (visivel) liga(); else rodando = false;
      }).observe(canvas);
    }
    // Mudar o tamanho do canvas apaga o desenho: redesenha na hora.
    window.addEventListener('resize', function () { mede(); quadro(performance.now()); });
    return {
      muda: function (tom, mb, mt) {
        est.alvo = FUSAO[tom];
        est.forcaAlvo = tom === 'nenhuma' ? 0.35 : 1;
        est.cores = [['#a8843f', '#d6b97a'], ['#c9b48c', '#efe4cc']];
        if (!est.iniciado) { est.f = est.alvo * 0.2; est.iniciado = true; }
        liga();
      }
    };
  })();

  var FRASCO = '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9.5" y="2.8" width="5" height="3.6" rx="1"/><rect x="8" y="6.4" width="8" height="14.8" rx="2.2"/><path d="M8 13.2h8"/></svg>';
  var LUPA = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 4 4"/></svg>';
  var SETA = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m9 6 6 6-6 6"/></svg>';
  var PAPEL = { base: 'Base', topo: 'Por cima' };
  var PEDIDO = { base: 'Escolha a base', topo: 'Escolha o de cima' };

  function etiquetas(p) {
    var t = '';
    if (p.c) t += '<span class="lx-etiqueta">' + escapa(p.c) + '</span>';
    if (p.g) t += '<span class="lx-etiqueta lx-etiqueta--' + p.g + '">' + GENEROS[p.g] + '</span>';
    return t ? '<span class="lx-etiquetas">' + t + '</span>' : '';
  }

  function foto(p, classe) {
    return '<span class="' + classe + '">' +
      (p.img ? '<img src="' + escapa(p.img) + '" alt="" width="360" height="450" loading="lazy" data-lx-foto>' : FRASCO) + '</span>';
  }

  // A foto de todo decant na loja segue o molde 4:5, e o CSS mostra só o miolo,
  // como nos cartões. Foto fora do molde aparece inteira; foto que não carrega
  // dá lugar ao desenho do frasco.
  function confereFoto(e) {
    var img = e.target;
    if (!img || !img.hasAttribute || !img.hasAttribute('data-lx-foto')) return;
    if (e.type === 'error') {
      if (img.parentNode) img.parentNode.innerHTML = FRASCO;
      return;
    }
    if (Math.abs(img.naturalWidth / img.naturalHeight - 0.8) > 0.01) img.classList.add('is-inteira');
  }
  document.addEventListener('load', confereFoto, true);
  document.addEventListener('error', confereFoto, true);

  // O nome com o trecho buscado em destaque (sem ligar para acentos).
  function destaca(nome, termos) {
    if (!termos.length) return escapa(nome);
    var letras = Array.from(nome);
    var plano = letras.map(function (l) { return semAcento(l); });
    var junto = plano.join('');
    var marca = new Array(letras.length).fill(false);
    termos.forEach(function (t) {
      var de = junto.indexOf(t);
      if (de < 0) return;
      var pos = 0;
      plano.forEach(function (pedaco, k) {
        if (pos < de + t.length && pos + pedaco.length > de) marca[k] = true;
        pos += pedaco.length;
      });
    });
    var html = '', aberto = false;
    letras.forEach(function (l, k) {
      if (marca[k] && !aberto) { html += '<mark>'; aberto = true; }
      if (!marca[k] && aberto) { html += '</mark>'; aberto = false; }
      html += escapa(l);
    });
    return html + (aberto ? '</mark>' : '');
  }

  function iniciarLaboratorio(perfumes, maisVendidosH) {
    var porH = {};
    perfumes.forEach(function (p) { porH[p.h] = p; });
    var maisVendidos = maisVendidosH.map(function (h) { return porH[h]; }).filter(Boolean);
    if (maisVendidos.length < 8) maisVendidos = maisVendidos.concat(perfumes.slice(0, 8 - maisVendidos.length));
    var emOrdem = perfumes.slice().sort(function (a, b) { return a.n.localeCompare(b.n, 'pt-BR'); });
    var escolha = {
      base: porH[raiz.getAttribute('data-lx-base')] || maisVendidos[0],
      topo: porH[raiz.getAttribute('data-lx-topo')] || maisVendidos[1]
    };

    function mostra(chave) {
      var p = escolha[chave];
      var caixa = $('[data-fl-slot="' + chave + '"] [data-fl-escolhido]', lab);
      caixa.classList.remove('lx-escolhido--carregando');
      if (!p) { caixa.innerHTML = ''; return; }
      caixa.innerHTML = foto(p, 'lx-escolhido__foto') +
        '<span class="lx-escolhido__texto"><span class="lx-escolhido__nome">' + escapa(p.n) + '</span>' +
        '<span class="lx-escolhido__marca">' + escapa(p.m) + '</span>' + etiquetas(p) + '</span>' +
        '<span class="lx-escolhido__trocar">Trocar' + SETA + '</span>';
      caixa.setAttribute('aria-label', PAPEL[chave] + ': ' + p.n + ', ' + p.m + (p.c ? ', ' + p.c : '') + '. Trocar o perfume');
    }

    // Os layerings recomendados da página: o Laboratório os reconhece pelos
    // dois produtos do cartão, em qualquer ordem.
    var recomendados = {};
    var handleDe = function (a) {
      var m = a && /\/products\/([^?#/]+)/.exec(a.getAttribute('href') || '');
      return m ? m[1] : '';
    };
    $$('.lx-trilho .lx-dupla').forEach(function (c) {
      var hb = handleDe(c.querySelector('.lx-frasco--base')), ht = handleDe(c.querySelector('.lx-frasco--topo'));
      if (!hb || !ht) return;
      var txt = function (sel) { var el = c.querySelector(sel); return el ? el.textContent.trim() : ''; };
      var doses = (/(\d+)\s*\+\s*(\d+)/.exec(txt('.lx-dupla__dose b')) || []).slice(1, 3).map(Number);
      recomendados[hb + '|' + ht] = { nome: txt('.lx-dupla__nome'), porque: txt('.lx-dupla__porque'), doses: doses.length === 2 ? doses : null };
    });

    var FRASE_CONFLITO = {
      'dois-pesados': 'Os dois são intensos e quentes e disputam espaço: nenhum aparece direito. Troque um deles por um perfume mais leve ou mais fresco.',
      'doce-sobre-doce': 'Doce sobre doce deixa a mistura enjoativa. Por cima de um perfume doce, prefira um fresco ou um amadeirado seco.',
      'aquatico-com-pesado': 'Um perfume aquático com um oriental intenso costuma embolar. Troque um dos dois.'
    };
    // A seleção é a dos cartões da página, e a página não diz a fonte (decisões do dono, 17/10); fora dela, a leitura é só pelas notas.
    var AINDA = ' Este par ainda não está na nossa seleção.';
    function veredito(b, t, nComuns) {
      var rec = recomendados[b.h + '|' + t.h], invertida = false;
      if (!rec && recomendados[t.h + '|' + b.h]) { rec = recomendados[t.h + '|' + b.h]; invertida = true; }
      if (rec) {
        return { chave: 'recomendado', rec: rec, invertida: invertida, nivel: 4, tom: 'forte', selo: 'Recomendado',
          titulo: 'Recomendado pela Frenesi', frase: rec.porque };
      }
      var r = avaliaPar(b, t);
      if (r.veredito === 'evite') {
        return { chave: 'evite', nivel: 1, tom: 'nenhuma', selo: 'Evite', titulo: 'Não recomendamos', frase: FRASE_CONFLITO[r.conflitos[0]] };
      }
      if (r.veredito === 'boa') {
        var frase = r.motivo === 'ponte'
          ? 'Os dois têm ' + lista(r.pontes.slice(0, 2).map(function (x) { return ACORDE_NO_TEXTO[x] || x; })) + ' no coração ou no fundo, e isso liga um ao outro.'
          : r.motivo === 'classico' ? r.classico
            : t.n + ' é leve e fresco e ilumina o fundo quente de ' + b.n + '.';
        return { chave: 'boa', nivel: 3, tom: r.motivo === 'contraste' ? 'contraste' : 'boa', selo: 'Boa aposta', titulo: 'Boa aposta pelas notas', frase: frase + AINDA };
      }
      return { chave: 'incerto', nivel: 2, tom: 'ousada', selo: 'Incerto', titulo: 'Resultado incerto',
        frase: (nComuns
          ? 'O que eles dividem é de saída, que evapora logo, ou de fundo comum a muitos perfumes: isso não segura a mistura. E eles não formam um contraste clássico.'
          : 'Eles não têm notas em comum nem formam um contraste clássico.') + ' Teste numa fita olfativa antes de usar na pele.' };
    }

    var selo = $('[data-fl-selo]', lab);
    var afinidade = $('[data-fl-afinidade]', lab);
    var titulo = $('[data-fl-titulo]', lab);
    var texto = $('[data-fl-texto]', lab);
    var comum = $('[data-fl-comum]', lab);
    var aviso = $('[data-fl-aviso]', lab);
    var dose = $('[data-fl-dose]', lab);
    var preco = $('[data-fl-preco]', lab);
    var tamanhos = $('[data-fl-tamanhos]', lab);
    var botao = $('[data-fl-adicionar-dupla]', lab);

    var escolhaMl = { base: TAMANHO_INICIAL, topo: TAMANHO_INICIAL };
    function inverte() {
      var x = escolha.base; escolha.base = escolha.topo; escolha.topo = x;
      var ml = escolhaMl.base; escolhaMl.base = escolhaMl.topo; escolhaMl.topo = ml;
      mostra('base'); mostra('topo'); calcula();
    }

    function calcula() {
      var b = escolha.base, t = escolha.topo;
      if (!b || !t) return;
      if (b.h === t.h) {
        selo.textContent = 'Escolha dois perfumes';
        titulo.textContent = 'Escolha dois perfumes';
        texto.textContent = 'A base e o de cima precisam ser perfumes diferentes.';
        afinidade.setAttribute('data-nivel', '0');
        comum.innerHTML = ''; aviso.hidden = true; dose.textContent = ''; preco.textContent = '—'; tamanhos.replaceChildren();
        botao.disabled = true;
        botao.setAttribute('data-lx-bloqueado', '');
        reator.muda('nenhuma', macro(b.f), macro(t.f));
        return;
      }
      botao.removeAttribute('data-lx-bloqueado');
      // Com um pedido em andamento, o botão só volta quando a sacola responder.
      if (!botao.classList.contains('is-carregando')) botao.disabled = false;
      var comuns = notasEmComum(b, t);
      var mb = macro(b.f), mt = macro(t.f);
      var v = veredito(b, t, comuns.length);
      lab.setAttribute('data-lx-veredito', v.chave);
      selo.textContent = v.selo;
      titulo.textContent = v.titulo;
      texto.textContent = v.frase;
      afinidade.setAttribute('data-nivel', String(v.nivel));
      afinidade.setAttribute('aria-label', 'Afinidade ' + v.nivel + ' de 4: ' + v.selo);
      comum.innerHTML = comuns.length
        ? '<li class="lx-comum__rotulo" aria-hidden="true">Em comum</li>' + comuns.slice(0, 4).map(function (n) { return '<li>' + escapa(n) + '</li>'; }).join('')
        : '';

      var ib = b.it == null ? 3 : b.it, iT = t.it == null ? 3 : t.it;
      var avisos = [];
      // O mais intenso vai primeiro (Abdulla Ajmal, perfumista); na seleção, vale a ordem indicada.
      var inverter = v.rec ? v.invertida : iT - ib >= 1;
      if (inverter) {
        avisos.push(v.rec ? 'Na seleção, ' + t.n + ' vai primeiro, como base.' : t.n + ' é mais intenso que ' + b.n + ': funciona melhor como base.');
      }
      if (!v.rec && ib >= 4 && iT >= 4 && v.chave !== 'evite') avisos.push('Os dois são intensos: comece com 1 borrifada de cada.');
      if (avisos.length) {
        aviso.hidden = false;
        aviso.innerHTML = '<span>' + escapa(avisos.join(' ')) + '</span>' + (inverter ? '<button type="button" data-fl-inverter-aviso>Inverter a ordem</button>' : '');
        var inv = aviso.querySelector('[data-fl-inverter-aviso]');
        if (inv) inv.addEventListener('click', inverte);
      } else {
        aviso.hidden = true;
        aviso.innerHTML = '';
      }
      var db = ib >= 4.5 ? 1 : 2;
      var dt = iT >= 4 ? 1 : 2;
      if (ib >= 4 && iT >= 4) { db = 1; dt = 1; }
      // Na seleção, a dose é a que a curadoria indicou para o cartão.
      if (v.rec && v.rec.doses && !v.invertida) { db = v.rec.doses[0]; dt = v.rec.doses[1]; }
      // Não faz sentido ensinar a dose de um par que o Laboratório desaconselha.
      dose.innerHTML = v.chave === 'evite' ? '' : '<b>Como usar</b>' + (db === 1 ? '1 borrifada' : db + ' borrifadas') + ' de ' + escapa(b.n) + ' e, por cima, ' + dt + ' de ' + escapa(t.n) + '.';
      // O tamanho de cada um: a escolha da pessoa vale enquanto o perfume tiver
      // aquele tamanho; a troca de perfume não apaga a escolha.
      tamanhos.replaceChildren(seletorDeTamanhos([
        { papel: 'Base', nome: b.n, tams: b.tams, ml: escolhaMl.base },
        { papel: 'Por cima', nome: t.n, tams: t.tams, ml: escolhaMl.topo }
      ], function (esc) {
        escolhaMl.base = esc[0].ml;
        escolhaMl.topo = esc[1].ml;
        preco.textContent = brl(esc[0].preco + esc[1].preco);
        botao.setAttribute('data-variantes', esc[0].v + ',' + esc[1].v);
        botao.setAttribute('aria-label', 'Adicionar ' + b.n + ' (' + esc[0].ml + ' ml) e ' + t.n + ' (' + esc[1].ml + ' ml) à sacola');
      }));
      reator.muda(v.tom, mb, mt);
    }

    botao.addEventListener('click', function () { adicionar(botao.getAttribute('data-variantes'), botao); });
    var trocaBotao = $('[data-fl-inverter]', lab);
    if (trocaBotao) trocaBotao.addEventListener('click', inverte);

    // ── A busca: tela cheia no celular, janela no computador ──
    var seletor = document.createElement('div');
    seletor.className = 'lx lx-seletor';
    seletor.hidden = true;
    seletor.setAttribute('role', 'dialog');
    seletor.setAttribute('aria-modal', 'true');
    seletor.setAttribute('aria-labelledby', 'lx-seletor-titulo');
    seletor.tabIndex = -1;
    seletor.innerHTML =
      '<div class="lx-seletor__fundo" data-fl-fechar></div>' +
      '<div class="lx-seletor__caixa">' +
        '<div class="lx-seletor__topo"><span class="lx-slot__n" aria-hidden="true" data-fl-n>1</span>' +
          '<p class="lx-seletor__titulo" id="lx-seletor-titulo"></p>' +
          '<button type="button" class="lx-fechar" data-fl-fechar aria-label="Fechar a busca">' + XIS + '</button></div>' +
        '<div class="lx-busca">' + LUPA +
          '<input type="search" role="combobox" aria-expanded="true" aria-autocomplete="list" aria-controls="lx-seletor-lista" ' +
          'placeholder="Nome, marca ou EDP/EDT" aria-label="Buscar perfume" autocomplete="off" autocapitalize="off" spellcheck="false" enterkeyhint="search">' +
          '<button type="button" class="lx-busca__limpar" aria-label="Limpar a busca" hidden>' + XIS + '</button></div>' +
        '<div class="lx-seletor__filtros" role="group" aria-label="Gênero">' +
          '<button type="button" data-genero="" aria-pressed="true">Todos</button>' +
          '<button type="button" data-genero="feminino" aria-pressed="false">Feminino</button>' +
          '<button type="button" data-genero="masculino" aria-pressed="false">Masculino</button>' +
          '<button type="button" data-genero="unissex" aria-pressed="false">Unissex</button></div>' +
        '<ul class="lx-seletor__lista" id="lx-seletor-lista" role="listbox" aria-label="Perfumes"></ul>' +
      '</div>';
    document.body.appendChild(seletor);

    var campo = seletor.querySelector('input');
    var limpar = seletor.querySelector('.lx-busca__limpar');
    var listaEl = seletor.querySelector('.lx-seletor__lista');
    var tituloSel = seletor.querySelector('#lx-seletor-titulo');
    var numeroSel = seletor.querySelector('[data-fl-n]');
    var chaveAtual = 'base';
    var genero = '';
    var ativo = -1;

    function opcao(p, k, termos) {
      var outra = escolha[chaveAtual === 'base' ? 'topo' : 'base'];
      var atual = escolha[chaveAtual] && escolha[chaveAtual].h === p.h;
      var ocupado = outra && outra.h === p.h;
      var estado = atual ? 'Escolhido' : ocupado ? (chaveAtual === 'base' ? 'Já vai por cima' : 'Já é a base') : '';
      return '<li class="lx-op" role="option" id="lx-op-' + k + '" data-h="' + escapa(p.h) + '" aria-selected="' + atual + '"' +
        (ocupado ? ' aria-disabled="true"' : '') + '>' + foto(p, 'lx-op__foto') +
        '<span class="lx-op__texto"><span class="lx-op__nome">' + destaca(p.n, termos) + '</span>' +
        '<span class="lx-op__marca">' + escapa(p.m) + '</span>' + etiquetas(p) + '</span>' +
        '<span class="lx-op__preco">' + brl(p.pRef) + '<small>' + p.mlRef + ' ml</small>' +
        (estado ? '<span class="lx-op__estado">' + estado + '</span>' : '') + '</span></li>';
    }

    function desenha() {
      var q = semAcento(campo.value).trim();
      var termos = q ? q.split(/\s+/) : [];
      var doGenero = function (p) { return !genero || p.g === genero; };
      var html = '', k = 0;
      limpar.hidden = !q;
      if (!termos.length) {
        var topo = maisVendidos.filter(doGenero);
        var vistos = {};
        topo.forEach(function (p) { vistos[p.h] = true; });
        var resto = emOrdem.filter(function (p) { return doGenero(p) && !vistos[p.h]; });
        if (topo.length) {
          html += '<li class="lx-seletor__grupo" role="presentation">Mais vendidos</li>';
          html += topo.map(function (p) { return opcao(p, k++, termos); }).join('');
        }
        html += '<li class="lx-seletor__grupo" role="presentation">Todos, de A a Z</li>';
        html += resto.map(function (p) { return opcao(p, k++, termos); }).join('');
      } else {
        var achados = perfumes.filter(function (p) {
          return doGenero(p) && termos.every(function (x) { return p.busca.indexOf(x) !== -1; });
        }).sort(function (a, b) {
          var na = semAcento(a.n), nb = semAcento(b.n);
          var ia = na.indexOf(q) === 0 ? 0 : na.indexOf(termos[0]) === 0 ? 1 : 2;
          var ib = nb.indexOf(q) === 0 ? 0 : nb.indexOf(termos[0]) === 0 ? 1 : 2;
          return ia - ib || a.n.localeCompare(b.n, 'pt-BR');
        });
        html += '<li class="lx-seletor__grupo" role="presentation">' +
          (achados.length === 1 ? '1 perfume' : achados.length + ' perfumes') + '</li>';
        html += achados.map(function (p) { return opcao(p, k++, termos); }).join('') ||
          '<li class="lx-seletor__vazio" role="presentation">Nenhum perfume com esse nome' + (genero ? ' em ' + GENEROS[genero].toLowerCase() : '') + '. Tente pela marca.</li>';
      }
      listaEl.innerHTML = html;
      listaEl.scrollTop = 0;
      ativo = -1;
      campo.removeAttribute('aria-activedescendant');
    }

    function escolhe(h) {
      var p = porH[h];
      var outra = escolha[chaveAtual === 'base' ? 'topo' : 'base'];
      if (!p || (outra && outra.h === p.h)) return;
      escolha[chaveAtual] = p;
      mostra(chaveAtual);
      calcula();
      fechaJanela(false);
    }

    function abreBusca(chave) {
      chaveAtual = chave;
      tituloSel.textContent = PEDIDO[chave];
      numeroSel.textContent = chave === 'base' ? '1' : '2';
      campo.value = '';
      desenha();
      // No celular o teclado só sobe quando a pessoa toca na busca: antes, ela
      // vê os mais vendidos inteiros.
      abreJanela(seletor, null, celular.matches ? seletor : campo);
    }

    $$('[data-fl-slot]', lab).forEach(function (slot) {
      var chave = slot.getAttribute('data-fl-slot');
      $('[data-fl-escolhido]', slot).addEventListener('click', function () { abreBusca(chave); });
    });

    campo.addEventListener('input', desenha);
    limpar.addEventListener('click', function () { campo.value = ''; desenha(); campo.focus(); });
    $$('[data-genero]', seletor).forEach(function (b) {
      b.addEventListener('click', function () {
        genero = b.getAttribute('data-genero');
        $$('[data-genero]', seletor).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        desenha();
      });
    });
    seletor.addEventListener('click', function (e) {
      if (e.target.closest('[data-fl-fechar]')) { fechaJanela(false); return; }
      var li = e.target.closest('.lx-op');
      if (li && li.getAttribute('aria-disabled') !== 'true') escolhe(li.getAttribute('data-h'));
    });
    campo.addEventListener('keydown', function (e) {
      var ops = listaEl.querySelectorAll('.lx-op:not([aria-disabled="true"])');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!ops.length) return;
        ativo = (ativo + (e.key === 'ArrowDown' ? 1 : -1) + ops.length) % ops.length;
        Array.prototype.forEach.call(ops, function (o, k) { o.classList.toggle('is-ativo', k === ativo); });
        campo.setAttribute('aria-activedescendant', ops[ativo].id);
        ops[ativo].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        e.preventDefault();
        var alvo = ops[ativo] || (semAcento(campo.value).trim() && ops.length === 1 ? ops[0] : null);
        if (alvo) escolhe(alvo.getAttribute('data-h'));
        else campo.blur();
      }
    });

    mostra('base');
    mostra('topo');
    calcula();
  }

  // Enquanto a vitrine não chega, os cartões mostram que estão carregando.
  $$('[data-fl-escolhido]', lab).forEach(function (c) {
    c.classList.add('lx-escolhido--carregando');
    c.textContent = 'Carregando os perfumes…';
  });

  var maisVendidosH = [];
  try { maisVendidosH = JSON.parse(($('[data-lx-mais-vendidos]', lab) || {}).textContent || '[]'); } catch (e) {}

  var url = raiz.getAttribute('data-lx-erp');
  var carregou = false;
  function carregar() {
    if (carregou || !url) return;
    carregou = true;
    fetch(url, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('vitrine ' + r.status); return r.json(); })
      .then(function (dados) {
        var perfumes = perfumesDoLab(dados);
        if (perfumes.length < 2) throw new Error('vitrine vazia');
        $$('[data-lx-total]').forEach(function (el) {
          if (el.hasAttribute('data-lx-conta')) el.setAttribute('data-lx-conta', String(perfumes.length));
          el.textContent = String(perfumes.length);
        });
        iniciarLaboratorio(perfumes, maisVendidosH);
      })
      ['catch'](function () {
        // Sem a vitrine, o Laboratório sai da página (e o atalho para ele também).
        lab.hidden = true;
        $$('a[href="#laboratorio"]').forEach(function (a) { a.hidden = true; });
      });
  }
  // A vitrine é lida logo depois da carga da página, sem atrasar a abertura.
  if ('requestIdleCallback' in window) window.requestIdleCallback(carregar, { timeout: 2500 });
  else setTimeout(carregar, 1200);
  if (temObservador) {
    var perto = new IntersectionObserver(function (itens) {
      if (itens[0].isIntersecting) { carregar(); perto.disconnect(); }
    }, { rootMargin: '900px 0px' });
    perto.observe(lab);
  }
})();
